import $ from "jquery";
import {
  ChangeGlobalMorph,
  ConvertMorphValue,
  modelForExport,
  pergola,
} from "../../../../../../core/3d-configurator";
import {
  cloneLouverFirst,
  cloneLouverSecond,
  cloneLouverThird,
  cloneStorage,
} from "../../../../../../core/customFunctions/customFunctions";
import { MORPH_DATA, state, getHeightMorph, getLengthMorph, getWidthMorph } from "../../../../../../core/settings";
import "./generateRange.scss";
import { lightRange, shadesRange } from "../../../../../portal/rangeArrays";

export function capitalize(str) {
  if (str && str.length > 0) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
  return str;
}

export const typesDirection = {
  width: "width",
  length: "length",
  height: "height",
};

export function generateRangeHTML(range) {
  const dimensionTitles = ["Louvre Span (m)", "Pivot (m)", "Height (m)"];

  // Override min/max for dimension sliders based on roof type
  if (range.title === "Pivot (m)") {
    const widthRange = state.roofType === 1 ? MORPH_DATA.retractable.width : MORPH_DATA.opening.width;
    range = { ...range, min: widthRange.min, max: widthRange.max };
  }
  if (range.title === "Louvre Span (m)") {
    const lengthRange = state.roofType === 1 ? MORPH_DATA.retractable.length : MORPH_DATA.opening.length;
    range = { ...range, min: lengthRange.min, max: lengthRange.max };
  }

  if (range.initialValue < range.min) range = { ...range, initialValue: range.min };
  if (range.initialValue > range.max) range = { ...range, initialValue: range.max };

  const extraClass = dimensionTitles.includes(range.title) ? "range__input__dimensions" : "";
  const extraWrapper = dimensionTitles.includes(range.title) ? "range__wrapper_dimensions" : "";

  const customRangeHTML = `
  <div class="range">
      <label class="range__label" for="range__input">${range.title}</label>

      <div class="range__wrapper ${extraWrapper}">
          <input 
              type="range" 
              id="range__input" 
              class="range__input ${extraClass}" 
              min="${range.min}" 
              max="${range.max}" 
              step="${range.step}" 
              value="${range.initialValue}">

            ${range.thumb
      ? `<div class="range__thumb-value" id="range__thumb-value">${range.initialValue}</div>`
      : ""
    }

            ${range.showLabels
      ? `
                      <div class="range__values">
                          <span class="range__value range__value--min" id="range__min">${range.labelMin ? range.labelMin : range.min
      }</span>
                          <span class="range__value range__value--max" id="range__max">${range.labelMax ? range.labelMax : range.max
      }</span>
                      </div>`
      : ""
    }
        </div>
    </div>

    ${range.showSwitchAngle &&
    `
         <div class="direction">
             <label class="range__label" for="range__input">Direction</label>

             <div class="direction__switch">
                <p class="direction__switch-off switch_active">Clockwise</p>
        
                <label class="switch">
                    <input type="checkbox" class="switch__input" id="switch-input">
                    <span class="switch__slider"></span>
                </label>
    
                <p class="direction__switch-on">Counter clockwise</p>
             </div>
         </div>
        `
    }
  `;

  const activeSwitchClass = "switch_active";
  const $customRange = $(customRangeHTML);
  const $switchInput = $customRange.find(".switch__input");
  const $rangeLabel = $customRange.find(".range__label");
  const $rangeInputId = $customRange.find("#range__input");
  const $rangeInput = $customRange.find(".range__input");
  const $rangeThumbValue = $customRange.find(".range__thumb-value");

  // INIT SWITCH BUTTON
  const $slider = $(this).next(".switch__slider");

  function updateSwitchState(isRotated) {
    if (isRotated) {
      $slider.addClass(activeSwitchClass);
      $customRange
        .find(".direction__switch-off")
        .removeClass(activeSwitchClass);
      $customRange.find(".direction__switch-on").addClass(activeSwitchClass);
      $switchInput.prop("checked", true);
    } else {
      $slider.removeClass(activeSwitchClass);
      $customRange.find(".direction__switch-off").addClass(activeSwitchClass);
      $customRange.find(".direction__switch-on").removeClass(activeSwitchClass);
      $switchInput.prop("checked", false);
    }
  }

  // // updateSwitchState(state.isRotated);

  // // HANDLE SWITCH
  // $switchInput.on("change", function () {
  //   state.isRotated = !state.isRotated;
  //   pergola.update();
  //   // updateSwitchState(state.isRotated);
  // });

  //THUMB HANDLE
  function updateThumbValue(trigger) {
    const min = parseFloat($rangeInput.attr("min"));
    const max = parseFloat($rangeInput.attr("max"));
    const value = parseFloat($rangeInput.val());

    const labelInputs = $rangeLabel.text().trim();

    let newHeaderText = "";

    //update Param Head
    if (range.thumb) {
      const labelInputs = $rangeLabel.text().trim();

      switch (labelInputs) {
        case "Louvre Span (m)":
          MORPH_DATA.length.initValue = value;
          break;
        case "Pivot (m)":
          MORPH_DATA.width.initValue = value;
          break;
        case "Height (m)":
          MORPH_DATA.height.initValue = value;
          break;
      }

      newHeaderText = `${MORPH_DATA.length.initValue}m x ${MORPH_DATA.width.initValue}m x ${MORPH_DATA.height.initValue}m`;

      $(trigger)
        .closest(".interface__group")
        .find(".interface__group__head__param")
        .text(newHeaderText);
    }

    //calc thumb value position
    const borderForHide = 0;

    if (range.thumb) {
      if (
        (value >= min &&
          value <= min + borderForHide &&
          max - min > borderForHide * 2) ||
        (value >= max - borderForHide &&
          value <= max &&
          max - min > borderForHide * 2)
      ) {
        $rangeThumbValue.hide();
      } else {
        $rangeThumbValue.show();
        $rangeThumbValue.text(
          range.inch ? value.toString().concat(``) : value
        );

        const percent = ((value - min) / (max - min)) * 100;
        const thumbSize = 16; // matches CSS thumb width
        const trackW = $rangeInput.outerWidth() || 314;
        const thumbCenterPx = thumbSize / 2 + (trackW - thumbSize) * (percent / 100);
        const lw = $rangeThumbValue.outerWidth() || (value.toString().length * 8 + 4);
        const minLabelW = $customRange.find('.range__value--min').outerWidth() || 0;
        const maxLabelW = $customRange.find('.range__value--max').outerWidth() || 0;
        const leftPx = Math.max(minLabelW, Math.min(thumbCenterPx - lw / 2, trackW - maxLabelW - lw));
        $rangeThumbValue.css("left", leftPx + "px");
      }

      if (value === min || value === max) {
        $rangeThumbValue.hide();
      }
    }

    $rangeInput.css(
      "background",
      `linear-gradient(to right, #629A33 ${((value - min) / (max - min)) * 100
      }%, #629A334D ${((value - min) / (max - min)) * 100}%)`
    );
  }

  //init calc
  updateThumbValue();

  function changeMorph(directions, inputValue) {
    switch (directions) {
      case typesDirection.length:
        ChangeGlobalMorph("length", getLengthMorph(inputValue));
        ChangeGlobalMorph("length_wall", getLengthMorph(inputValue));
        break;

      case typesDirection.width:
        ChangeGlobalMorph("width", getWidthMorph(inputValue));
        ChangeGlobalMorph("width_wall", getWidthMorph(inputValue));
        break;

      case typesDirection.height:
        ChangeGlobalMorph("height", getHeightMorph(inputValue));
        break;

      default:
        console.log("non correct directions");
        return;
    }
  }

  $rangeInput.on("input", function () {
    updateThumbValue(this);
  });

  // //HANDLE Spacing LIGHT
  if (range.title === shadesRange[0].title) {
    $rangeInputId.on("input", function (event) {
      state.zipInput = event.target.value;

      let correctMorphForShade = 0;

      const morphOffsets = {
        8: { morph: 0, offset: 0 },
        9: { morph: 0.12, offset: 0 },
        10: { morph: 0.26, offset: 0 },
        11: { morph: 0.38, offset: 0 },
        12: { morph: 0.52, offset: 0 },
      };

      if (morphOffsets[state.height]) {
        correctMorphForShade = morphOffsets[state.height].morph;
      }

      let baseMorph = ConvertMorphValue(
        event.target.value,
        1,
        90,
        0,
        1 + correctMorphForShade
      );

      state.ledLights = baseMorph;

      ChangeGlobalMorph("close", baseMorph);
    });
  }

  //HANDLE Spacing LIGHT
  if (range.title === lightRange[0].title) {
    $rangeInputId.on("input", function (event) {
      state.recessedLighting = event.target.value;
      pergola.update();
    });
  }

  //CONECT 'Rotation' input to MODEL
  if (range.title === "Rotation") {
    console.log($rangeInputId, "range");

    $rangeInputId.on("input", function (event) {
      state.currentRotationZ = event.target.value;
      console.log(event.target.value);
      applyRotationToClones(event.target.value);
    });
  }

  // CHANGE WIDTH
  if (range.title === "Pivot (m)") {
    $rangeInputId.on("input", function (event) {
      state.width = +event.target.value;
      changeMorph(typesDirection.width, event.target.value);
      pergola.update();
    });
  }

  // CHANGE LENGTH
  if (range.title === "Louvre Span (m)") {
    $rangeInputId.on("input", function (event) {
      state.length = +event.target.value;
      changeMorph(typesDirection.length, event.target.value);
      pergola.update();
    });
  }

  // CHANGE HEIGHT
  if (range.title === "Height (m)") {
    $rangeInputId.on("input", function (event) {
      state.height = +event.target.value;
      changeMorph(typesDirection.height, event.target.value);
      pergola.update();
    });
  }

  return $customRange;
}
